import type { PDFDocumentProxy } from 'pdfjs-dist/web/pdf_viewer';
import React from 'react';

import { Client } from '../../../Types/client';
import { Department } from '../../../Types/department';
import { Invoice } from '../../../Types/invoice';
import { useInvoicesListResult } from '../Types/Invoices/useInvoicesList';

interface InvoiceContextProps {
  invoiceId: string;
  invoice: Invoice;
  openInvoices: useInvoicesListResult;
  paidInvoices: useInvoicesListResult;
  creditedInvoices: useInvoicesListResult;
  department: Department;
  pdfs: PDFDocumentProxy[];
  invoicePdf: PDFDocumentProxy;
  client: Client;
  clearCache: () => Promise<void>;
  madeTooManyPaymentAttempts: boolean;
  setMadeTooManyPaymentAttempts: (value: boolean) => void;
}

const InvoiceContext = React.createContext<Partial<InvoiceContextProps>>({});

export default InvoiceContext;
